<template>
  <div>
    <b-carousel
      id="carousel-1"
      indicators
    >
      <b-carousel-slide class="contact-slide">
        <template #img>
          <anchor-contact
            v-if="originator"
            card-title="Your Anchor Team"
            :name="originator.name"
            contact-title="Account Executive"
            :email="originator.email"
            :phone="originator.phone"
          />
          <anchor-contact
            v-else
            card-title="Contact"
            name="Main Office"
            email="info@anchorloans.com"
            phone="(888) 719-5299"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
import AnchorContact from '@/components/utils/AnchorContact';

export default {
  name: 'AnchorTeam',
  components: { AnchorContact },
  computed: {
    originator() {
      return this.$store.getters.accountExecutive;
    },
  },
};
</script>


<style scoped>
.anchor-team-title {
  color: var(--primary-color);
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
}

.anchor-contact-name {
  font-weight: 550;
}

.anchor-contact-function {
  font-weight: 100;
  color: #929292;
}

.carousel-indicators li {
  background-color: var(--primary-color) !important;
}

.contact-slide {
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/sidebar/AnchorTeam.vue